import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Row, Col, Button } from "reactstrap";
import { Field, getFormValues, reduxForm, reset } from "redux-form";
// import MultipleSelectField from "../../commonfields/MultipleSelectField";
import FutureDatePicker from "../../commonfields/FutureDatePicker";
import FilterAssignments from "../../commonfields/FilterAssignments";
import moment from "moment";
import { clearFilters } from "./FiltersHelper";
import { CheckboxGroup, MultipleSelectField } from "common-fields";
import { TrackersEnum } from "../../models/TrackerModel";
import { useLocation } from "react-router-dom";

const FilterLeads = (props: any) => {
  const location = useLocation();
  const assignmentsObj = [
    { value: "My Leads", text: "My Leads" },
  ];

  const handleFormSubmit = (values: any) => {
    const trackersFiltersDataObj = {
      states: values.states?.map((m: any) => m.value ?? m) ?? null,
      industryTypes: values.industryTypes?.map((m: any) => m.value ?? m) ?? null,
      productType: values.productType?.map((m: any) => m.value ?? m) ?? null,
      teamMembers:
        values?.assignmentType?.includes('My Leads') ?
          values?.assignmentType ?? null :
          values.assignmentType?.map((m: any) => m.value) ?? null,
      salesOrganizations: values.salesOrganizations?.map((m: any) => m.value ?? m) ?? null,
      nextAction: values.nextAction ? moment(values.nextAction).format("MM/DD/YYYY") : null,
      expectedClose: values.expectedClose ? moment(values.expectedClose).format("MM/DD/YYYY") : null,
      archive: values?.archive?.length >= 1 ? [1] : values.archive ?? null,
    }
    const detailsFiltersDataObj = {
      campaigns: values.campaigns?.map((m: any) => m.value ?? m) ?? null,
      contacts: values.contacts?.map((m: any) => m.value ?? m) ?? null,
      interactions: values.interactions?.map((m: any) => m.text ?? m) ?? null,
      products: values.products?.map((m: any) => m.value ?? m) ?? null,
      // salesOrganizations : values.salesOrganization?.map((m: any) => m.value ?? m) ?? null,
      date: values.date ? moment(values.date).format("MM/DD/YYYY") : null,
      notesAndDocuments: values?.notesAndDocuments?.length >= 2 ? [3] : values.notesAndDocuments ?? null,
    }
    if (props?.filterType === "trackersPageFilters") {
      props.getFiltersDataHandler(trackersFiltersDataObj, values);
    } else if (props?.filterType === "detailsPageFilters") {
      props.getFiltersDataHandler(detailsFiltersDataObj, values);
    }
  };

  const [onClear, setOnClear] = useState(false)

  const clearAll = () => {
    props?.dispatch(reset("FilterForm"));
    props?.clearSelection && props?.clearSelection();
    props.change("states", []);
    props.change("industryTypes", []);
    props.change("productType", []);
    props.change("salesOrganizations", []);
    props.change("teamMembers", []);
    props.change("nextAction", null);
    props.change("expectedClose", null);
    props.change("campaigns", []);
    props.change("contacts", []);
    props.change("interactions", []);
    props.change("products", []);
    props.change("notesAndDocuments", null);
    props.change("date", null);
    props.change("archive", null)

    // handleClearFromParent();
    setOnClear(true);
    clearFilters();
    props.clearAllfiltervalues()
  }


  return (

    <form onSubmit={props.handleSubmit(handleFormSubmit)}>
      {props?.filterType === "trackersPageFilters" &&
        <Row>
          <Col md="6" className="bizType statesWrap">
            <Field
              style={{ color: "red" }}
              name="states"
              component={MultipleSelectField}
              type="text"
              label="States"
              placeholder="Select State(s)"
              values={props?.filtersData?.[0]?.states || []}
              onClear={onClear}
              setOnClear={setOnClear}
            />
            <Field
              name="industryTypes"
              component={MultipleSelectField}
              type="text"
              label="Industry Type"
              placeholder="Select Type(s)"
              values={props?.filtersData?.[0]?.industrytypes || []}
              onClear={onClear}
              setOnClear={setOnClear}
            />
            {!location.pathname.includes(`${TrackersEnum.RELATIONSHIPS}`) && <Field  // not including for relationship tracker this filter
              name="archive"
              component={CheckboxGroup}
              type="text"
              label=""
              options={props?.archiveOptions}
            />}
            <Field
              name="assignmentType"
              component={FilterAssignments}
              type="text"
              label="Assignments"
              options={assignmentsObj}
              placeholder="Select Team Member(s)"
              teamMemberData=
              {props?.filtersData?.[0]?.teamMembers || []}
              onClear={onClear}
              setOnClear={setOnClear}
            />
          </Col>
          <Col md="6" className="filters-pop">
            {" "}
            <Field
              name="productType"
              component={MultipleSelectField}
              type="text"
              label="Opportunity"
              values={props?.filtersData?.[0]?.producttype || []}
              placeholder="Select Opportunity(s)"
              onClear={onClear}
              setOnClear={setOnClear}
            />
            <Field
              name="salesOrganizations"
              component={MultipleSelectField}
              type="text"
              label="Sales Organizations"
              values={props?.filtersData?.[0]?.salesOrganizations || []}
              placeholder="Select Sales Organization(s)"
              onClear={onClear}
              setOnClear={setOnClear}
            />
            {props?.getTrackerType === TrackersEnum.PROSPECTING ?
              <><div style={{ position: "relative" }}>
                <label>Next Action</label>
                <Field
                  name="nextAction"
                  component={FutureDatePicker}
                  placeholderText={'Select Date(s)'}
                  minDate={new Date()} />
              </div><div style={{ position: "relative" }}>
                  <label>Expected Close</label>
                  <Field
                    name="expectedClose"
                    component={FutureDatePicker}
                    placeholderText={'Select Date(s)'}
                    minDate={new Date()} />
                </div></> : null}
          </Col>
        </Row>
      }
      {props?.filterType === "detailsPageFilters" &&
        <Row>
          <Col md="6" className="bizType statesWrap">
            <Field
              style={{ color: "red" }}
              name="campaigns"
              component={MultipleSelectField}
              type="text"
              label="Action"
              placeholder="Select Action(s)"
              values={props?.filtersData?.[0]?.campaigns ?? []}
              onClear={onClear}
              setOnClear={setOnClear}
            />
            <Field
              name="contacts"
              component={MultipleSelectField}
              type="text"
              label="Contact"
              placeholder="Select Contact(s)"
              values={props?.filtersData?.[0]?.contacts || []}
              onClear={onClear}
              setOnClear={setOnClear}
            />
            <Field
              name="interactions"
              component={MultipleSelectField}
              type="text"
              label="Interaction"
              placeholder="Select Interaction(s)"
              values=
              {props?.filtersData?.[0]?.interactions || []}
              onClear={onClear}
              setOnClear={setOnClear}
            />
            <Field
              name="products"
              component={MultipleSelectField}
              type="text"
              label="Product"
              placeholder="Select Product(s)"
              values={props?.filtersData?.[0]?.products || []}
              onClear={onClear}
              setOnClear={setOnClear}
            />
          </Col>
          <Col md="6" className="filters-pop">
            {" "}
            <label>Date</label>
            <Field
              name="date"
              component={FutureDatePicker}
              placeholder="Select Date(s)"
              maxDate={new Date()}
            />
            <Field
              name="notesAndDocuments"
              component={CheckboxGroup}
              type="text"
              label="Documents and Notes"
              // helpText="Status"
              options={props?.notesAndDocumentsData}
            />
            {/* <Field
          name="salesOrganization"
          component={MultipleSelectField}
          type="text"
          label="Sales Organizations"
          values=
          {props?.filtersData?.[0]?.salesOrganizations.map((m:any)=>Object.keys(m).length)>0? props?.filterData?.[0]?.teamMembers : []}
          placeholder="Select Sales Organization(s)"
        /> */}
          </Col>
        </Row>
      }
      <div className="filterBtns">
        <Button onClick={() => clearAll()}>Clear All</Button>
        <Button color="primary"> Apply</Button>
      </div>
    </form>
  );
};

const mapStateToProps = (state: any, props: any) => {
  return ({

    initialValues: {
      states: props?.selectedFilters?.states || [],
      productType: props?.selectedFilters?.productType || [],
      industryTypes: props?.selectedFilters?.industryTypes || [],
      salesOrganizations: props?.selectedFilters?.salesOrganizations || [],
      assignmentType: props?.selectedFilters?.assignmentType || [],
      nextAction: props?.selectedFilters?.nextAction
        ? moment(props?.selectedFilters?.nextAction).format("MM/DD/YYYY")
        : null,
      expectedClose: props?.selectedFilters?.expectedClose
        ? moment(props?.selectedFilters?.expectedClose).format("MM/DD/YYYY") : null,
      campaigns: props?.selectedFilters?.campaigns || [],
      contacts: props?.selectedFilters?.contacts || [],
      interactions: props?.selectedFilters?.interactions || [],
      products: props?.selectedFilters?.products || [],
      notesAndDocuments: props?.selectedFilters?.notesAndDocuments ?? null,
      date: props?.selectedFilters?.date
        ? moment(props?.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
      archive: props?.selectedFilters?.archive ?? null,
    },
    formValues: getFormValues("FilterForm")(state),
  })
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "FilterForm", // a unique identifier for this form
    enableReinitialize: true,
  })(FilterLeads)
);
